export const getDefaultGetters = {
  isAuthenticated(state){
    return state.isAuthenticated;
  },
  getIngredients: state => state.ingredients,
  isIngredientsLoading: state => state.ingredientsLoading,
  postsLoading: state => state.postsLoading,
  getTagItems: state => state.tagItems,
  getPosts: state => state.posts,
  totalPosts: state => state.totalPosts,
  postsOptions: state => state.postsOptions,
  getPostCategories: state => state.postsCategories,
  loadingPostToEdit: state => state.loadingPostToEdit,
  postToEdit : state => state.postToEdit,
  allowedToEdit: state => state.allowedToEdit,
  postIsSaved: state => state.postIsSaved,
  customToolBar: state => state.customToolBar,
  getCharts: state => state.charts
};
